<template>
	<div class="banner-container" >
		<div class="container">
			<h2>쿠팡 1P/2P 전용 서비스</h2>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return{

			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			},
		},

	}
</script>

<style>
	.banner-container {
		width: 100%;
		height: 280px;
		position: relative;
		overflow: hidden;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #eee;
	}

	.container{
		text-align: center;
	}
	.banner-container .container h2 {
	    font-weight: 700;
	    font-size: 42px !important;
	    color: #1E3A5F;
		letter-spacing: -0.5px;
	}
	@media (max-width: 768px) {
		.banner-container{
			height: 200px;
		}
		.banner-container .container h2 {
		    font-size: 42px !important;
		}
	}
</style>
